import { DragIndicatorOutlined } from '@mui/icons-material';
import { Paper, Table, TableBody, TableCell, TableRow } from '@mui/material';

interface DragOverlayRowProps {
  item: any;
  columns: typeof columns;
}
const DragOverlayRow: React.FC<DragOverlayRowProps> = ({ item, columns }) => {
  const overlayColumns = columns.filter((col) => !['thumbnailSrc', 'actions'].includes(col.id ?? col.accessorKey));
  return (
    <Paper
      elevation={6}
      sx={{
        opacity: 0.5,
        borderRadius: 1,
        width: '90vw', // ← fix: constrain to a sensible width
        maxWidth: '90vw',
        overflow: 'hidden',
      }}
    >
      <Table size="small">
        <TableBody>
          <TableRow
            sx={{
              backgroundColor: 'background.paper',
              cursor: 'grabbing',
              '& td': { borderBottom: 'none' },
            }}
          >
            {/* Drag handle placeholder */}
            <TableCell sx={{ width: 40, py: 1 }}>
              <DragIndicatorOutlined sx={{ color: 'text.disabled', fontSize: 18 }} />
            </TableCell>

            {overlayColumns.map((col) => {
              // After createColumnHelper, the renderer lives on col.columnDef.cell
              const accessorKey = col.accessorKey as string | undefined;
              const value = accessorKey
                ? (accessorKey.split('.') as string[]).reduce((obj: any, key: string) => obj?.[key], item)
                : null;

              // Build a minimal CellContext that satisfies the cell renderer
              const cellContext = {
                getValue: () => value,
                renderValue: () => value,
                row: {
                  original: item,
                  getValue: (key: string) => (item as any)[key],
                },
                column: col,
                table: {},
                cell: {},
              } as any;

              const cellFn = col.columnDef?.cell;

              return (
                <TableCell key={col.id ?? accessorKey} sx={{ py: 1 }}>
                  {typeof cellFn === 'function' ? cellFn(cellContext) : String(value ?? '')}
                </TableCell>
              );
            })}
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

export default DragOverlayRow;
